import validator from 'validator';

export const postalCodeFormat = (postalCode) => {
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
  );
  const code = orgData?.country?.code || 'US';
  return validator.isPostalCode(postalCode ?? "", code);
}

export const postalCodeLabel = () => {
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
  );
  const postalLabel = orgData?.country?.postalLabel || 'Zip Code';
  return postalLabel;
}


export const stateLabel = () => {
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
  );
  const state = orgData?.country?.stateLabel || 'State';
  return state;
}